/*
 * fn: cleanAdvancedFilters
 *
 * Cleans a list of advanced filters to ensure it is valid
 *
 */
import {
  FILTER_ADVANCED_MAX,
  type FilterAdvancedPartialType,
  type FilterAdvancedType,
  isFilterAdvancedCardType,
  isFilterAdvancedCountType,
  isFilterAdvancedPriceType,
  isFilterAdvancedType,
} from '@/defs/filters'

export const cleanAdvancedFilters = (advanced: FilterAdvancedPartialType[] = []): FilterAdvancedType[] | undefined => {
  if (advanced.length < 1) return

  return advanced
    .map((f) => {
      if (isFilterAdvancedCardType(f)) return { card: f.card, slug: f.slug }
      if (isFilterAdvancedCountType(f)) return { number: f.number, operator: f.operator, slug: f.slug }
      if (isFilterAdvancedPriceType(f)) return { number: f.number, operator: f.operator, slug: f.slug }
    })
    .filter((f) => isFilterAdvancedType(f))
    .slice(-FILTER_ADVANCED_MAX)
}
